export class IconsMapping{
    private static readonly icons:any = {
        "DesignSystem":"dso",
        "Conversational":"conversational-flows",
        "WebPanel":"webpanel"
    }
    public static getIcon(obj:string){
        return `objects/${IconsMapping.icons[obj]}`;
    }
}